(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savium-reviews"] && !Shopify.designMode) return;
  try {
    

(() => {

  const sections = document.querySelectorAll(
    '.savium-reviews'
  );

  if (!sections.length) return;

  sections.forEach((section) => {

    const openButton = section.querySelector(
      '[data-open-review-form]'
    );

    const closeButton = section.querySelector(
      '[data-close-review-form]'
    );

    const formWrapper = section.querySelector(
      '[data-review-form]'
    );

    const form = section.querySelector(
      '[data-review-form-element]'
    );

    const ratingButtons = section.querySelectorAll(
      '[data-rating]'
    );

    const ratingValue = section.querySelector(
      '[data-rating-value]'
    );

    const formMessage = section.querySelector(
      '[data-form-message]'
    );


    /*
     * OPEN REVIEW FORM
     */

    if (openButton && formWrapper) {

      openButton.addEventListener('click', () => {

        formWrapper.hidden = false;

        formWrapper.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });

      });

    }


    /*
     * CLOSE REVIEW FORM
     */

    if (closeButton && formWrapper) {

      closeButton.addEventListener('click', () => {

        formWrapper.hidden = true;

      });

    }


    /*
     * STAR RATING
     */

    ratingButtons.forEach((button) => {

      button.addEventListener('click', () => {

        const selectedRating =
          Number(button.dataset.rating);

        if (ratingValue) {
          ratingValue.value = selectedRating;
        }

        ratingButtons.forEach((star) => {

          const starRating =
            Number(star.dataset.rating);

          if (starRating <= selectedRating) {

            star.classList.add('is-selected');

            star.setAttribute(
              'aria-pressed',
              'true'
            );

          } else {

            star.classList.remove('is-selected');

            star.setAttribute(
              'aria-pressed',
              'false'
            );

          }

        });

      });

    });


    /*
     * FORM
     *
     * Persistence will be connected separately.
     */

    if (form) {

      form.addEventListener('submit', (event) => {

        event.preventDefault();

        if (!ratingValue || !ratingValue.value) {

          if (formMessage) {

            formMessage.hidden = false;

            formMessage.textContent =
              'Please select a rating before submitting your review.';

          }

          return;

        }

        if (formMessage) {

          formMessage.hidden = false;

          formMessage.textContent =
            'Thank you. Your review has been received and is awaiting approval.';

        }

      });

    }

  });

})();


  } catch(e) { console.error(e); }
})();
})();
